
// CardFooter.tsx
import React from 'react';

interface CardFooterProps {
  children: React.ReactNode;
  className?: string;
}

const CardFooter = ({ children, className = '' }: CardFooterProps) => (
  <div className={`border-indigo-700 border-t rounded-b-md p-4 ${className}`}>
    {children}
  </div>
);

export default CardFooter;
